import { makeStyles } from '@mui/styles';

import { appColors, backgroundColors } from 'src/consts/app-config';

export const useStyles = makeStyles({
    desktopUserSettingsWrapper: {
        // width: '600px',
        width: '100%',
        height: '450px',
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
    },

    desktopUserSettingsTabPanel: {
        '&.MuiTabPanel-root': {
            padding: '20px 0px',
        },
    },

    tabs: {
        width: '100%',
        minHeight: '35px !important',
        '& .MuiTabs-indicator': {
            background: appColors.white,
        },
        '& .MuiTabs-scroller': {
            width: '100%',
        },
        '& .MuiTabs-flexContainer': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly',
        },
    },
    tab: {
        display: 'flex!important',
        alignItems: 'center!important',
        padding: '0!important',
        minWidth: '0px!important',
        minHeight: '0px!important',
        color: 'rgba(255, 255, 255, 0.3) !important',
        fontSize: '16px!important',
        // @ts-ignore
        fontWeight: '500!important',
        // @ts-ignore
        textTransform: 'none!important',
        '&.Mui-selected': {
            color: 'rgba(245, 245, 245, 1) !important',
            fontWeight: '700!important',
        },
    },
});
